// frontend/src/components/ErrorBoundary.js

import React from 'react';
import log from '../logger';
import { Alert } from 'react-bootstrap';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    log.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <Alert variant="danger">Something went wrong.</Alert>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
